/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react';
import Dropdown from '../../../common/dropdown/Dropdown';
import ReactGA from 'react-ga4';
import { TStep3Info } from '../../../types';
import Button from '../../global/Button';
import plusIcon from '../../../assets/images/tbh/dashboardImages/plus.svg';

import './businessRegistration.css';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import { useAppSelector } from '../../../app/hooks';

type TProps = {
  info: TStep3Info;
  setInfo: React.Dispatch<React.SetStateAction<TStep3Info>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  states: any[];
  setStates: React.Dispatch<React.SetStateAction<any[]>>;
  nearestSterlingStates: any[];
  setNearestSterlingStates: React.Dispatch<React.SetStateAction<any[]>>;
  setShowAddBranchForm?: React.Dispatch<React.SetStateAction<boolean>>;
  lgaLoading: boolean;
  branchLoading: boolean;
};
const BusinessAddressForm = ({
  //info,
  setInfo,
  setStep,
  states,
  // setStates,
  nearestSterlingStates,
  // setNearestSterlingStates,
  setShowAddBranchForm,
  lgaLoading,
  branchLoading,
}: TProps) => {
  const [disabled, setDisabled] = useState(true);
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  // Inputs States
  const [businessInfo, setBusinessInfo] = useState({} as TStep3Info);
  const validateInputsResult = useMemo(() => {
    const isStreetNo = businessInfo.streetNumber;
    const isStreetName = businessInfo.streetName;
    const isState = businessInfo.selectedState;
    const isLga = businessInfo.selectedLga;
    const isNearestState = businessInfo?.nearestSterlingState?.label;
    const isNearestBranch = businessInfo.nearestSterlingBranch;
    const isHasBranch = businessInfo.hasBranch;
    const isNoOfBranch =
      businessInfo.hasBranch === 'Yes' ? businessInfo.noOfBranch?.toString() : true;
    return (
      isState &&
      isStreetName &&
      isStreetNo &&
      isLga &&
      isNearestState &&
      isNearestBranch &&
      isHasBranch &&
      isNoOfBranch
    );
  }, [businessInfo]);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);
  return (
    <div className='flex justify-center flex-col md:w-full mx-auto'>
      <form className='stepThree formCont'>
        <div className='w-full'>
          <h4 className='mb-2'>Street number and name</h4>
          <div className='mb-[27px] flex gap-3 '>
            <div className='w-[90px]'>
              <div className=''>
                {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none !rounded-[4px]'
                  value={businessInfo.streetNumber}
                  placeholder={'#'}
                  onChange={(e) => {
                    setBusinessInfo((prev) => ({ ...prev, streetNumber: e.target.value }));
                  }}
                />
              </div>
            </div>
            <div className='w-full'>
              <div className='mb-[27px]'>
                {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
                <input
                  className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none !rounded-[4px]'
                  value={businessInfo.streetName}
                  placeholder={'Type street name'}
                  onChange={(e) => {
                    setBusinessInfo((prev) => ({
                      ...prev,
                      streetName: e.target.value.replace(/[0-9]/g, ''),
                      // streetName: e.target.value.replace(/[^a-z] /gi, ''),
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <div className='w-full text-xs mb-[27px]'>
            <Dropdown
              className='border !rounded-[4px] !h-[52px] '
              label='Located State'
              placeholder={''}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={
                states &&
                states.map((state: any) => {
                  return {
                    label: state.name,
                    value: state.name,
                  };
                })
              }
              width='100%'
              isLoading={lgaLoading}
              value={businessInfo.selectedState}
              setSelectedOption={(e: { label: string; value: string }) => {
                setBusinessInfo((prev) => ({ ...prev, selectedState: e.label }));
              }}
            />
            {/* )}
              /> */}
          </div>
          <div className='w-full text-xs mb-[27px] '>
            <Dropdown
              className='border !rounded-[4px] !h-[52px] '
              setSelectedOption={(e: { label: string; value: string }) => {
                setBusinessInfo((prev) => ({ ...prev, selectedLga: e.label }));
              }}
              // value={businessInfo.selectedLga}
              label='Local Government Area'
              placeholder={businessInfo.selectedLga}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={
                states &&
                states
                  ?.find((item: any) => item?.name === businessInfo.selectedState)
                  ?.lgas?.map((item: any) => {
                    return {
                      label: item,
                      value: item,
                    };
                  })
              }
              width='100%'
              isLoading={lgaLoading}
            />
            {/* )}
              /> */}
          </div>
          <div className='w-full text-xs mb-[27px] '>
            <Dropdown
              className='border !rounded-[4px] !h-[52px] '
              placeholder={businessInfo?.nearestSterlingState?.value}
              label='Sterling Bank Location'
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={nearestSterlingStates?.map((state: any) => {
                return {
                  label: state?.state,
                  value: state?.state,
                  lgas: state?.listOfBranches,
                };
              })}
              width='100%'
              isLoading={branchLoading}
              setSelectedOption={(e: { label: string; value: string; lgas: string[] }) => {
                setBusinessInfo((prev) => ({ ...prev, nearestSterlingState: e }));
              }}
            />
          </div>
          <div className='w-full text-xs mb-[27px] '>
            <Dropdown
              className='border !rounded-[4px] !h-[52px] !py-2'
              label='Preferred Sterling Bank Branch'
              placeholder={businessInfo?.nearestSterlingBranch}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={businessInfo?.nearestSterlingState?.lgas?.map((item: any) => {
                return {
                  label: item?.address,
                  value: item?.address,
                };
              })}
              width='100%'
              isLoading={branchLoading}
              setSelectedOption={(e: { label: string; value: string }) => {
                setBusinessInfo((prev) => ({ ...prev, nearestSterlingBranch: e.label }));
              }}
            />
          </div>
          <div className='w-full text-xs mb-[27px] '>
            <Dropdown
              placeholder={businessInfo?.hasBranch ?? ''}
              className='border !rounded-[4px] h-[52px] '
              label='Does your business exist in other locations asides the address above?'
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={[
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' },
              ]}
              setSelectedOption={(e: { label: string; value: string }) => {
                setBusinessInfo((prev) => ({ ...prev, hasBranch: e.label }));
              }}
              width='100%'
            />
          </div>
          {businessInfo.hasBranch === 'Yes' && (
            <div className='w-full text-xs mb-[27px] '>
              <Dropdown
                placeholder={businessInfo.noOfBranch?.toString() ?? ''}
                className='border !rounded-[4px] h-[52px] '
                label='How many outlets?'
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={[
                  { value: 1, label: 1 },
                  { value: 2, label: 2 },
                  { value: '3 or more', label: '3 or more' },
                ]}
                setSelectedOption={(e: { label: number; value: number }) => {
                  setBusinessInfo((prev) => ({ ...prev, noOfBranch: e.label }));
                }}
                width='100%'
                hideSearchBar
              />
            </div>
          )}
        </div>
        {businessInfo.hasBranch === 'Yes' ? (
          <div className='flex justify-center flex-col md:w-full  mx-auto'>
            <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
              <Button
                className='px-5 !py-[10px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-none '
                size='sm'
                underline={false}
                theme='secondary'
                onClick={() => {
                  setStep((currPage: any) => currPage - 1);
                }}
              >
                PREVIOUS
              </Button>
              <Button
                // type='submit'
                size='sm'
                className='!bg-[#76839624] font-bold text-[10px] !text-green '
                icon={plusIcon}
                onClick={() => {
                  setInfo(businessInfo);
                  setShowAddBranchForm && setShowAddBranchForm(true);
                }}
                disabled={disabled}
              >
                Add new branch
              </Button>
            </div>
          </div>
        ) : (
          <div className='flex justify-center flex-col md:w-full  mx-auto'>
            <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
              <Button
                className='h-[40px] text-[11px] !bg-[#768396] text-white border-[0px] rounded-[6px] '
                size='sm'
                underline={false}
                theme='secondary'
                onClick={() => {
                  registerNetcoreActivity(
                    {
                      emailAddress: details?.email,
                      firstName: details?.firstName,
                      lastName: details?.lastName,
                      mobileNumber: details?.phoneNumber,
                    },
                    'TBH_BUSINESS_REGISTRATION_STEP_5',
                  );
                  ReactGA.event({
                    category: 'formSubmit',
                    action: 'TBH_BUSINESS_REGISTRATION_STEP_5',
                    label: 'TBH_BUSINESS_REGISTRATION_STEP_5',
                    // value: 1
                  });
                  setStep((currPage: any) => currPage - 1);
                }}
              >
                PREVIOUS
              </Button>
              <Button
                disabled={disabled}
                type='submit'
                theme='primary'
                className='!h-[40px] !rounded-[6px] text-[11px] inline-block !border-none'
                size='sm'
                underline={false}
                onClick={() => {
                  setInfo(businessInfo);
                  setStep((prev) => prev + 1);
                  // TODO----!
                  // route to step 4
                }}
              >
                SAVE AND CONTINUE
              </Button>
            </div>
          </div>
        )}
      </form>
      {/* </FormProvider> */}
    </div>
  );
};

export default BusinessAddressForm;
